import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SkipStepForLead as SkipStepForLeadMutation,
    SkipStepForLeadVariables,
    SkipStepInput,
} from 'nutshell-graphql-types';

import SKIP_STEP_FOR_LEAD from '../mutations/skip-step-for-lead.graphql';

export const useSkipStepForLead = (): {
    skipStepForLead: (arg1: SkipStepInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [skipStepForLead, {loading, error}] = useMutation<
        SkipStepForLeadMutation,
        SkipStepForLeadVariables
    >(SKIP_STEP_FOR_LEAD);

    return {
        skipStepForLead: (input: SkipStepInput) => skipStepForLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
